
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cheap-storage-places",
      function () {
        return require("private-next-pages/cheap-storage-places/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cheap-storage-places"])
      });
    }
  